'use strict';
import { observable, action } from 'mobx';
import { fetch, buildUrl } from '@/lib/fetchAPI';
import { getEchartsArr } from '../../lib/lib';
import {
  DeviceStatusBtnGroup,
  OnlineModalColumns
} from '../../const/TableConst';

class StatisticsStore {
  @observable statisticsModalStatus = false;
  @observable modalLoading = false;
  @observable modalTitle = '';
  @observable deviceStatusArr = { title: '', xData: [], yData: [], color: [] };
  @observable deviceStatusBtnGroup = DeviceStatusBtnGroup;
  @observable columns = [];
  @observable dataSource = [];

  @action.bound
  hideModal() {
    this.statisticsModalStatus = false;
  }

  @action
  loadDeviceStatus(start, end, province, city) {
    let param = buildUrl({
      start: start,
      end: end,
      province: province,
      city: city
    });
    fetch(`/api/statistics/online${param}`, { method: 'GET' }, json => {
      this.deviceStatusArr = getEchartsArr({
        title: '设备上线次数',
        data: [...json],
        information: [
          { name: '在线设备数(台)', dataName: 'onlineCount' },
          { name: '离线设备数(台)', dataName: 'offlineCount' },
          { name: '激活设备数(台)', dataName: 'activeCount' }
        ],
        color: ['#52C41A', '#F5222D', '#FFD100'],
        xDataName: 'date'
      });
    });
  }
  @action.bound
  loadOnlineCountModalData({ label, value }, start, end, cityData) {
    let param = buildUrl({
      start: start,
      end: end,
      online_count: value,
      not: 'false',
      page_size: 100000,
      page_num: 1,
      province: cityData.length ? cityData[0] : undefined,
      city: cityData[1] || undefined
    });
    this.statisticsModalStatus = true;
    this.modalLoading = true;
    this.modalTitle = label;
    fetch(
      `/api/statistics/device/online_count/detail${param}`,
      { method: 'GET' },
      json => {
        this.dataSource = [...json.content].map((item, index) => {
          item['key'] = index;
          return item;
        });
        this.columns = OnlineModalColumns;
        this.modalLoading = false;
      }
    );
  }
}
export default new StatisticsStore();



// WEBPACK FOOTER //
// ./src/store/Statistics/Statistics.js